import { UserAuthority } from './user-authority';
/**
 * Authenticated User.
 *
 * @author Warlock, AIS.PL
 */
var AuthenticatedUser = /** @class */ (function () {
    function AuthenticatedUser() {
    }
    /**
     * Returns newly created user with properties defined by its JSON representation.
     *
     * @param jsonObject JSON object holding user properties
     */
    AuthenticatedUser.fromJSON = function (jsonObject) {
        var authorities = (jsonObject.authorities
            ? Array.from(jsonObject.authorities, function (authority) { return UserAuthority.fromString(authority); })
            : []);
        var id = jsonObject.id ? Number(jsonObject.id) : null;
        var dealerId = jsonObject.dealerId ? Number(jsonObject.dealerId) : null;
        var result = Object.create(AuthenticatedUser.prototype);
        return Object.assign(result, {
            authorities: authorities, id: id, dealerId: dealerId, username: jsonObject.username
        });
    };
    /**
     * Verifies if the user has any of the given authorities.
     *
     * @param first first authority to check
     * @param rest the rest of authorities to check
     */
    AuthenticatedUser.prototype.hasAuthority = function (first) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var expected = Array.from(rest);
        expected.unshift(first);
        return this.hasAnyOfAuthorities(expected);
    };
    /**
     * Verifies if the user has any of the given authorities.
     *
     * @param authorities authorities to check
     */
    AuthenticatedUser.prototype.hasAnyOfAuthorities = function (authorities) {
        return 0 < this.authorities.filter(function (authority) { return -1 !== authorities.indexOf(authority); }).length;
    };
    /**
     * Converts the user to its JSON representation.
     */
    AuthenticatedUser.prototype.toJSON = function () {
        return Object.assign({}, {
            authorities: this.authorities.map(function (authority) { return UserAuthority[authority]; }),
            id: this.id,
            dealerId: this.dealerId,
            username: this.username
        });
    };
    return AuthenticatedUser;
}());
export { AuthenticatedUser };
